import { z } from "zod";
export const refreshJobStatus = z.enum(["QUEUED", "RUNNING", "DONE", "FAILED"]);
export const refreshJobSchema = z.object({
    id: z.number(),
    idcompany: z.number(),
    companyName: z.string().nullable(),
    reportType: z.string(),
    status: refreshJobStatus,
    requestedBy: z.number().nullable(),
    requesterName: z.string().nullable(),
    queuedAt: z.string(),
    startedAt: z.string().nullable(),
    finishedAt: z.string().nullable(),
    durationMs: z.number().nullable(),
    errorMessage: z.string().nullable(),
});
export const queueRefreshSchema = z.object({
    idcompany: z.number().int().positive(),
    reportType: z.string().min(1).max(50),
});
//# sourceMappingURL=reporting.js.map